import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip'
import { useTokenDecimals } from '@/hooks/token/use-token-decimals'
import useCurrencyFormats from '@/hooks/use-currency-formats'
import { formatUnits } from 'viem'

interface TokenAmountProps {
  amount?: bigint | string
}

export default function Amount({ amount }: TokenAmountProps) {
  const { decimals = 6 } = useTokenDecimals()
  const { formatAmount, formatBlockchainAmount } = useCurrencyFormats()

  if (amount === undefined) return '-'

  const amountBigInt = typeof amount === 'string' ? BigInt(amount) : amount
  const numericAmount = Number(formatUnits(amountBigInt, decimals))

  return (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <span className="relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:border-b-2 after:border-dotted after:border-current after:opacity-20 cursor-help">
            {formatAmount(numericAmount)}
          </span>
        </TooltipTrigger>
        <TooltipContent>{formatBlockchainAmount(numericAmount)}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
